module.exports = {
          srcSet: __webpack_public_path__ + "92a5d3370499717ff76acc61936e76b4-31.png"+" 31w",
          images:[ {path: __webpack_public_path__ + "92a5d3370499717ff76acc61936e76b4-31.png",width: 31,height: 35}],
          src: __webpack_public_path__ + "92a5d3370499717ff76acc61936e76b4-31.png",
          toString:function(){return __webpack_public_path__ + "92a5d3370499717ff76acc61936e76b4-31.png"},
          
          width: 31,
          height: 35
        }